// client/src/components/UserAgreementPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './AgreementsPage.css'; // Shared CSS

function UserAgreementPage() {
  const {t} = useTranslation();
  return (
    <div className="policy-page">
      <h1>{t('Agreements.userAgreementTitle')}</h1>
      <p>
       {t('Agreements.userAgreementPlaceholder')}
      </p>
      {/* Add your actual user agreement content here */}
      </div>
  );
}

export default UserAgreementPage;